// @flow
import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import reducers from './reducers';
import sagas from './sagas';
import createPolicyMiddleware from "./policies/middleware";
import { createPluginModeWindowMiddleware } from './common';

const sagaMiddleware = createSagaMiddleware();
const policyMiddleware = createPolicyMiddleware();
const pluginModeWindowMiddleware = createPluginModeWindowMiddleware();
const middlewares = [sagaMiddleware, policyMiddleware, pluginModeWindowMiddleware];

export function configureStore(initialState: {}) {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 }) : compose;

    const store = createStore(reducers, initialState, composeEnhancers(applyMiddleware(...middlewares)));
    sagaMiddleware.run(sagas);

    // fixme: Remove this ugly thing
    window.store = store;

    return store;
}
